import React from 'react'
import _ from "lodash"
import { Tooltip } from 'antd'

function ProductionEfficiencyTable(props) {
    const { data: chartData, convertBins, isCompare, combineType, getQuantityType, productionState } = props
    const newData = !!isCompare && Array.isArray(chartData) ? chartData.map(i => convertBins(i)) : convertBins(chartData)
    const { labels: labels1, items = [], total = 0, avg_time = 0 } = (Array.isArray(newData) ? (newData[0] || {}) : newData || {})
    const formatNumber = (input) => {
        const n = Number(input)
        if (Number.isNaN(n)) return ''
        if (Number.isInteger(n)) return `${n}`
        return n.toFixed(2).replace('.', ',')
    }

    const getAverageProductionTime = () => {
        if (['printed_time', 'transferred_time', 'laser_cut_time', 'mex_time', 'sewing_time', 'sewed_time', 'receive_sew_time', 'completed_time'].includes(productionState)) {
            return 'Thời gian sản xuất lô trung bình'
        }

        if (['package_item_time', 'label_time', 'package_box_time'].includes(productionState)) {
            return 'Thời gian sản xuất item trung bình'
        }
        return 'Thời gian sản xuất trung bình'
    }

    return (
        <div className='TableReport ProductionEfficiencyTable my-4' >
            <table className='table' id='ExportTable'>
                <thead className="TableHeadReport" style={{ background: '#f1f1f1' }}>
                    <tr>
                        <th></th>
                        {!isCompare &&
                            <th style={{ fontSize: 14, fontWeight: 700, color: '#333' }}>AVG</th>
                        }
                        {Array.isArray(labels1) && labels1.map((i, idx) => (
                            <th key={`th_${idx}`} style={{ fontSize: 14, fontWeight: 700, color: '#333' }}>
                                {i}
                            </th>
                        ))}
                    </tr>
                </thead>

                {!!isCompare ?
                    <tbody>
                        {Array.isArray(newData) && newData.map((d, dIdx) => (
                            <tr key={`compareRow_${dIdx}`} className={`TableRowItem`}>
                                <td>{d.combinedName}</td>
                                {combineType === 'count' && Array.isArray(d.items) && d.items.map((i, idx) => (
                                    <td key={`tdCountCompare)${idx}`}>
                                        {i.value}
                                    </td>
                                ))}
                                {combineType === 'percent' && Array.isArray(d.items) && d.items.map((i, idx) => (
                                    <td key={`tdPercentCompare)${idx}`}>
                                        {(d.total === 0 ? 0 : Number(((i.value / d.total) * 100).toFixed(2)))} %
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody> :
                    <tbody>
                        <tr className={`TableRowItem`}>
                            <td>
                                {getQuantityType()}
                            </td>
                            <td>{_.get(chartData, 'total', 0)}</td>
                            {Array.isArray(items) && items.map((i, idx) => (
                                <td key={`tdCount)${idx}`}>
                                    {i.value}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <td>Tỷ lệ %</td>
                            <td className='font-weight-bold'>
                                {formatNumber(avg_time)}
                                <Tooltip title={getAverageProductionTime()}>
                                    <i className='fa fa-info-circle ml-1 text-info'></i>
                                </Tooltip>
                            </td>
                            {Array.isArray(items) && items.map((i, idx) => (
                                <td key={`tdPercent)${idx}`}>
                                    {(total === 0 ? 0 : Number(((i.value / total) * 100).toFixed(2)))}%
                                </td>
                            ))}
                        </tr>
                    </tbody>
                }
            </table>
        </div>
    )
}

export default ProductionEfficiencyTable